import { AfterViewInit, OnDestroy, Component, input, ElementRef } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { ContextService } from '../../context.service';

@Component({
  selector: 'mutara-alert',
  templateUrl: './alert.component.html',
  styles: ['.mat-icon { margin-top: 0.3em;}'],
  standalone: false
})
export class AlertComponent extends FieldType implements AfterViewInit, OnDestroy {
  
  icon = input<string>('')
  label = input<string>('');
  description = input<string>('');
  secondaryText = input<string>('');
  statusType = input<string>('neutral');
  receive: Subscription | undefined;

  constructor(public context: ContextService, public host: ElementRef) {
    super();
  }
  ngAfterViewInit(): void {
    this.receive = this.context.subscribeTo('readyToReceive', (isReady : boolean) => {
      if ( isReady ) {
        this.resetText();
      }
    });
  }

  ngOnDestroy(): void {
    this.receive?.unsubscribe();
  }

  resetText() : void {
    if ( this.label.length > 0 ) {
      this.props.label = this.label();
    }
    if ( this.description.length > 0 ) {
      this.props.description = this.description();
    }
    if ( this.secondaryText.length > 0 ) {
      this.props.secondaryText = this.secondaryText();
    }
    this.statusType.apply( this.props.statusType ?? 'neutral' );
  }
  get isVisible() : boolean {
    return !this.field.hide && (!!this.props.label || !!this.props.description || this.props.secondaryText);
  }
}
